const validateForm = (data) => {
  let errors = { hasError: false, msg: {} };
  const emailformat = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;

  if (!data.invoiceEmail || !data.invoiceEmail.match(emailformat)) {
    errors.hasError = true;
    errors.invoiceEmail = true;
    errors.msg.invoiceEmail = '*Email is not valid';
  }

  if (data.additionalEmail && !data.additionalEmail.match(emailformat)) {
    errors.hasError = true;
    errors.additionalEmail = true;
    errors.msg.additionalEmail = '*Email is not valid';
  }

  if (!data.requestAmount) {
    errors.hasError = true;
    errors.requestAmount = true;
  }

  return errors;
};

export default validateForm;